import * as turf from '@turf/turf';

export const mapboxGLDrawRectangleDrag = (setDragAcres) => ({
  onSetup: function () {
    const t = this.newFeature({
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Polygon',
        coordinates: [[]],
      },
    })

    return (
      this.addFeature(t),
      this.clearSelectedFeatures(),
      this.updateUIClasses({ mouse: 'add' }),
      this.setActionableState({ trash: true }),
      setTimeout(() => {
        const { map: t } = this,
          a = t && t.doubleClickZoom
        t && a && a.disable()
      }, 0),
      { rectangle: t }
    )
  },
  onMouseDown: function (t, e) {
    e.preventDefault()
    const a = [e.lngLat.lng, e.lngLat.lat]
    t.startPoint = a
    t.rectangle.updateCoordinate('0.0', t.startPoint[0], t.startPoint[1])
  },
  onTouchStart: function (t, e) {
    e.preventDefault()
    const a = [e.lngLat.lng, e.lngLat.lat]
    t.startPoint = a
    t.rectangle.updateCoordinate('0.0', t.startPoint[0], t.startPoint[1])
  },
  onDrag: function (t, e) {
    if (t.startPoint) {
      t.rectangle.updateCoordinate('0.1', e.lngLat.lng, t.startPoint[1])
      t.rectangle.updateCoordinate('0.2', e.lngLat.lng, e.lngLat.lat)
      t.rectangle.updateCoordinate('0.3', t.startPoint[0], e.lngLat.lat)
      t.rectangle.updateCoordinate('0.4', t.startPoint[0], t.startPoint[1])
    }
    const topRight = [e.lngLat.lng, t.startPoint[1]];
    const bottomRight = [e.lngLat.lng, e.lngLat.lat];
    const bottomLeft = [t.startPoint[0], e.lngLat.lat];

    // Compute area dynamically
    const polygon = turf.polygon([[
        t.startPoint,
        topRight,
        bottomRight,
        bottomLeft,
        t.startPoint // Close the polygon
    ]]);

    let areaSqMeters = turf.area(polygon);
    let areaAcres = areaSqMeters * 0.000247105;
    setDragAcres(areaAcres.toFixed(2))
  },
  onTouchEnd: function (t, e) {
    t.endPoint = [e.lngLat.lng, e.lngLat.lat]
    this.updateUIClasses({ mouse: 'pointer' })
    this.changeMode('simple_select', { featuresId: t.rectangle.id })
  },
  onMouseUp: function (t, e) {
    t.endPoint = [e.lngLat.lng, e.lngLat.lat]
    this.updateUIClasses({ mouse: 'pointer' })
    this.changeMode('simple_select', { featuresId: t.rectangle.id })
  },
  onStop: function (t) {
    var e = this
    setTimeout(() => {
      const t = e._ctx && e._ctx.store
      const a = e.map && e.map
      if (a || t.getInitialValue) {
        t.getInitialConfigValue('doubleClickZoom') && a.doubleClickZoom.enable()
      }
    }, 0)

    this.updateUIClasses({ mouse: 'none' })

    if (this.getFeature(t.rectangle.id)) {
      t.rectangle.removeCoordinate('0.4')
      if (t.rectangle.isValid()) {
        this.map.fire('draw.create', { features: [t.rectangle.toGeoJSON()] })
      } else {
        this.deleteFeature([t.rectangle.id], { silent: true })
        this.changeMode('simple_select', {}, { silent: true })
      }
    }
  },
  onTrash: function (t) {
    this.deleteFeature([t.rectangle.id], { silent: true })
    this.changeMode('simple_select')
  },
  toDisplayFeatures: function (t, e, a) {
    const n = e.properties.id == t.rectangle.id
    e.properties.active = n.toString()
    n ? t.startPoint && a(e) : a(e)
  },
})
